import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { TextField, Grid, Button, Tooltip, Autocomplete } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { URLS } from "../../helpers/URLS";
import moment from "moment";
import useAxios from "../../helpers/Hooks/useAxios";
import DeleteIcon from '@mui/icons-material/Delete';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import './AddStatus.scss';

/* A project is bookable while its end date has not passed. Completed ones are
   left out of the list rather than shown greyed, so the dropdown only offers
   what can actually be chosen. */
const isProjectOpen = (project) =>
    new Date(moment(project?.projectEndDate).format('L')) >= new Date(moment().format('L'));

const AddStatus = ({ isStatusModel, modelHandle, statusPayload, setStatusPayload, statusObj, assignedProjectList, activitiesList, getDailyStatus,
    disabledDate = false, showAddRemoveBtns = true, handleTimeSheetEdit = () => { }, isAddNewTimeSheet = false, handleSaveNewTimeSheet = () => { }, isAddNewProject = false, handleSaveNewProject = () => { } }) => {




    useEffect(() => {
        handleTimeSheetEdit(statusPayload)
    }, [statusPayload])

    const paylaodData = statusPayload?.List[0]
    // console.log(statusPayload?.List[0], 'statusPayload?.List[0]')
const shouldDisableSubmitBtn = (data)=>{
    try{
        //console.log(data, 'data')
    let result = data?.List?.every((each)=> each?.projectID && each?.activityID && each?.description.trim() && parseInt(each?.hours)>=1)
    return !result
    }
    catch(error){
        return false
    }
}



  const handleManualChange = (e, index) => {
    const typed = e.target.value.trim();

    /* only digits, and the box has to be allowed to go empty so it can be
       retyped without selecting what is already in it first */
    if (typed !== '' && !/^\d+$/.test(typed)) {
        return;
    }

    const list = [...statusPayload.List];
    list[index].hours = typed === '' ? '' : Math.min(parseInt(typed, 10), 8);
    setStatusPayload({ ...statusPayload, List: list });
}


    const { fetchData } = useAxios();
    return (
        <div>
            <Modal size="lg" show={isStatusModel} onHide={modelHandle} backdrop="static" className="status-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add Work Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='work-report-section bg-white'>
                        <div className="">
                            {!isAddNewProject && <><div className="d-flex justify-content-between align-items-center pe-3">
                                <div className="form-group">
                                    <Grid item xs={6} sx={{ padding: 2 }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                                            <DesktopDatePicker
                                                label="Date"
                                                inputFormat="DD/MM/YYYY"
                                                value={statusPayload.date}
                                                maxDate={new Date()}
                                                onChange={(date) => { setStatusPayload({ ...statusPayload, date: new Date(date) }) }}
                                                renderInput={(params) => <TextField {...params} fullWidth required />}
                                                disabled={disabledDate}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </div>
                                {showAddRemoveBtns && <div className="status-add-wrap">
                                    <Button variant="outlined" className="status-add-btn"
                                        startIcon={<AddRoundedIcon />}
                                        onClick={(e) => {
                                            /* newest first, so the empty row to fill in is
                                               the one already in front of you */
                                            const list = [{ ...statusObj }, ...statusPayload.List];
                                            setStatusPayload({ ...statusPayload, List: list })
                                        }}>Add Report</Button>
                                </div>}
                            </div>
                                <hr />
                            </>}
                            <div className="modal_scroll px-3">
                                {statusPayload.List.map((row, index) => <div key={index} className="border-bottom py-3">
                                    {showAddRemoveBtns && <div className='status-row-head'>
                                        <span className='status-row-no'>Report {index + 1}</span>
                                        <Tooltip title="Delete this report" placement="top" arrow>
                                            <button type="button" className='btn btn-danger'
                                                aria-label="Delete this report"
                                                onClick={(e) => {
                                                    const list = [...statusPayload.List];
                                                    list.splice(index, 1);
                                                    setStatusPayload({ ...statusPayload, List: list })
                                                }}>
                                                <DeleteIcon fontSize="small" color="inherit" />
                                            </button>
                                        </Tooltip>
                                    </div>}
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <Autocomplete
                                                    sx={{ mt: 3 }}
                                                    fullWidth
                                                    size="small"
                                                    autoHighlight
                                                    options={assignedProjectList.filter((option) =>
                                                        /* keep whatever this row already points at, so editing an
                                                           older report does not silently blank its project */
                                                        isProjectOpen(option) || option.value === row.projectID)}
                                                    getOptionLabel={(option) => option?.label || ''}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    value={assignedProjectList.find(x => x.value === row.projectID) || null}
                                                    ListboxProps={{ className: 'status-listbox' }}
                                                    componentsProps={{ paper: { className: 'status-ac-paper' } }}
                                                    onChange={(event, option) => {
                                                        const list = [...statusPayload.List];
                                                        list[index].projectID = option ? option.value : "";
                                                        list[index].activityID = "";
                                                        setStatusPayload({ ...statusPayload, List: list })
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Project" />}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <Autocomplete
                                                    sx={{ mt: 3 }}
                                                    fullWidth
                                                    size="small"
                                                    autoHighlight
                                                    options={activitiesList}
                                                    getOptionLabel={(option) => option?.label || ''}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    disabled={row.projectID === '' ? true : false}
                                                    value={activitiesList.find(x => x.value === row.activityID) || null}
                                                    ListboxProps={{ className: 'status-listbox' }}
                                                    componentsProps={{ paper: { className: 'status-ac-paper' } }}
                                                    onChange={(event, option) => {
                                                        const list = [...statusPayload.List];
                                                        list[index].activityID = option ? option.value : "";
                                                        setStatusPayload({ ...statusPayload, List: list })
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Activity" />}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 ">
                                            <div className="form-group">
                                                
                                                {/* <TextField 
                                                sx={{ mt: 3 }} id="outlined-basic" fullWidth   variant="outlined" placeholder="00:00" type="time" 
                                                inputProps={{
                                                    min: "00:00",
                                                    max: "08:00",
                                                  }}
                                                    value={row.hours}
                                                    //  onKeyDown={(event) => {
                                                    
                                                    //      if (!/[0-9]/.test(event.key) || parseInt(event.target.value>8)) {
                                                    //        event.preventDefault();
                                                    //     }
                                                    //  }} 
                                                    onChange={(obj) => {
                                                        const list = [...statusPayload.List];
                                                        list[index].hours = obj.target.value;
                                                        setStatusPayload({ ...statusPayload, List: list })
                                                    }} /> */}


                                            <TextField
                                                label='Hours'
                                                key={index}
                                                    fullWidth
                                                    variant="outlined"
                                                    placeholder="0"
                                                value={statusPayload?.List[index]?.hours || ''}
                                                    onChange={(e)=>handleManualChange(e,index)}
                                                    inputProps={{ inputMode: 'numeric' }}
                                                    sx={{ mt: 3 }}
                                                />





                        
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="form-group">
                                                <TextField sx={{ mt: 3 }} id="outlined-basic" rows={2} multiline label="Description" variant="outlined" fullWidth
                                                    value={row.description}
                                                    onChange={(obj) => {
                                                        const list = [...statusPayload.List];
                                                        list[index].description = obj.target.value;
                                                        setStatusPayload({ ...statusPayload, List: list })
                                                    }}
                                                    // disabled={isAddNewProject}
                                                    className="day-report-status-desc"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                {showAddRemoveBtns && <Modal.Footer>
                    <Button variant="contained" color='inherit' onClick={modelHandle} className="me-3">
                        Close
                    </Button>
                    <Button variant="contained" 
                    disabled={shouldDisableSubmitBtn(statusPayload)}
                        onClick={async (e) => {
                            const payload = {
                                ...statusPayload,
                                date: moment(statusPayload.date).format('YYYY-MM-DD')
                            };
                           
                            let workhours=0;
                            payload.List.forEach((item) => {
                                workhours += parseInt(item.hours);
                            });
                            if(workhours > 8) {
                                toast.error("Work hours should not exceed 8 hours")
                                return
                            }

                            const resp = await fetchData({ url: URLS.manageDailyStatus, method: 'post', body: payload });
                            if (resp.status === 200) {
                                toast.success(resp.message)
                                modelHandle();
                                getDailyStatus();
                            }
                            else {
                                toast.error(resp.message)
                            }
                        }} >
                        {statusPayload.dailystatusID ? "Update" : "Save"}
                    </Button>
                </Modal.Footer>
                }
                {isAddNewTimeSheet && <Modal.Footer>
                    <Button variant="contained" onClick={() => {
                        if (isAddNewProject) {
                            handleSaveNewProject(statusPayload)
                        } else {
                            handleSaveNewTimeSheet(statusPayload)
                        }
                        modelHandle()
                    }}
                        disabled={(paylaodData?.projectID && paylaodData?.activityID && paylaodData?.hours) ? false : true}
                    >
                        Save
                    </Button>
                </Modal.Footer>
                }
            </Modal>
        </div>
    )
}

export default AddStatus
